import { useContext, useState } from 'react';

import { IAccountOption } from '../portfolio-management';
import { WebSocketContext } from '../websocket-context/websocket-provider';

import { parseRiskSnapshots } from './risk-management.helpers';
import { IListRiskSnapshotsDataParams } from './types';

const LIST_RISK_SNAPSHOTS_ID = 'LIST_RISK_SNAPSHOTS';

export const useListRiskSnapshots = () => {
  const { sendMessage, subscribeToChannel } = useContext(WebSocketContext);
  const [listRiskSnapshotsLoading, setListRiskSnapshotsLoading] = useState(false);

  const [riskSnapshotsData, setRiskSnapshotsData] = useState<Record<string, Record<string, any>>>(
    {},
  );

  const handleListRiskSnapshotsResponse = (response: any, accounts: IAccountOption) => {
    if (!response || !response.result) {
      setListRiskSnapshotsLoading(false);
      return;
    }

    const parsedList = parseRiskSnapshots(response.result);
    setRiskSnapshotsData((prev: any) => ({
      ...prev,
      [accounts?.exchange]: {
        ...(prev[accounts?.exchange] || {}),
        [accounts?.name]: parsedList,
      },
    }));

    setListRiskSnapshotsLoading(false);
  };

  const getListRiskSnapshots = ({ accounts }: IListRiskSnapshotsDataParams) => {
    const source =
      accounts.exchange === 'otc'
        ? { account: accounts.name, venue: accounts.venue }
        : { name: accounts.name };

    const payload = {
      jsonrpc: '2.0',
      id: LIST_RISK_SNAPSHOTS_ID,
      method: 'list_risk_snapshots',
      params: {
        source,
      },
    };

    setListRiskSnapshotsLoading(true);
    sendMessage(JSON.stringify(payload));
    subscribeToChannel(LIST_RISK_SNAPSHOTS_ID, (response: any) =>
      handleListRiskSnapshotsResponse(response, accounts),
    );
  };

  return {
    getListRiskSnapshots,
    listRiskSnapshotsLoading,
    riskSnapshotsData,
  };
};
